import React, { useState } from "react";
import { Box, Radio, FormControlLabel, RadioGroup } from "@mui/material";
import NetworkLogo from "../../assets/Network-payment-method.svg";

const PaymentMethods = ({ paymentType, setPaymentType, t }) => {

  const handleMethodChange = (event) => {
    setPaymentType(event.target.value);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        background: "#fff",
        borderRadius: '4px',
        marginBottom: '16px',
        paddingBottom: '15px'
      }}
      role="presentation"
    >
      <Box className="px-5 pt-5 pb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p className="poppins" style={{ fontWeight: 600, fontSize: '16px' }}>{t('checkout.payment_methods')}</p>
      </Box>
      <RadioGroup
        value={paymentType}
        onChange={handleMethodChange}
      >
        <Box className="px-5 " style={{ height: '50px', width: 'auto', display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            value="cash_on_delivery"
            control={<Radio />}
            label={t('checkout.cash_on_delivery')}
            sx={{
              '& .MuiFormControlLabel-label': {
                fontFamily: 'Poppins'
              }
            }}
          />
        </Box>
        <Box className="px-5" style={{ height: '50px', width: 'auto', display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            value="network_payment"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img src={NetworkLogo} alt="Network Payment" style={{ height: '24px', width: 'auto', marginLeft: '8px' }} />
              </Box>
            }
          />
        </Box>
      </RadioGroup>
    </Box>
  );
};

export default PaymentMethods;



// blocking cash on delivery and showing a warning toast when selected.
// import React, { useState } from "react";
// import {
//   Box,
//   Radio,
//   FormControlLabel,
//   RadioGroup,
//   Snackbar,
//   Alert
// } from "@mui/material";
// import NetworkLogo from "../../assets/Network-payment-method.svg";

// const PaymentMethods = ({ paymentType, setPaymentType, t }) => {
//   const [showWarning, setShowWarning] = useState(false);

//   const handleMethodChange = (event) => {
//     const selectedMethod = event.target.value;

//     if (selectedMethod === "cash_on_delivery") {
//       setShowWarning(true);
//       return;
//     }

//     setPaymentType(selectedMethod);
//   };

//   const handleCloseWarning = () => {
//     setShowWarning(false);
//   };

//   return (
//     <>
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           background: "#fff",
//           borderRadius: "4px",
//           marginBottom: "16px",
//           paddingBottom: "15px"
//         }}
//         role="presentation"
//       >
//         <Box
//           className="px-5 pt-5 pb-2"
//           style={{
//             display: "flex",
//             justifyContent: "space-between"
//           }}
//         >
//           <p
//             className="poppins"
//             style={{
//               fontWeight: 600,
//               fontSize: "16px"
//             }}
//           >
//             {t("checkout.payment_methods")}
//           </p>
//         </Box>

//         <RadioGroup
//           value={paymentType}
//           onChange={handleMethodChange}
//         >
//           <Box
//             className="px-5"
//             style={{
//               height: "50px",
//               width: "auto",
//               display: "flex",
//               alignItems: "center"
//             }}
//           >
//             <FormControlLabel
//               value="cash_on_delivery"
//               control={<Radio />}
//               label={t("checkout.cash_on_delivery")}
//               sx={{
//                 "& .MuiFormControlLabel-label": {
//                   fontFamily: "Poppins"
//                 }
//               }}
//             />
//           </Box>

//           <Box
//             className="px-5"
//             style={{
//               height: "50px",
//               width: "auto",
//               display: "flex",
//               alignItems: "center"
//             }}
//           >
//             <FormControlLabel
//               value="network_payment"
//               control={<Radio />}
//               label={
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <img
//                     src={NetworkLogo}
//                     alt="Network Payment"
//                     style={{
//                       height: "24px",
//                       width: "auto",
//                       marginLeft: "8px"
//                     }}
//                   />
//                 </Box>
//               }
//             />
//           </Box>
//         </RadioGroup>
//       </Box>

//       {/* Warning Toast */}
//       <Snackbar
//         open={showWarning}
//         autoHideDuration={3000}
//         onClose={handleCloseWarning}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "center"
//         }}
//       >
//         <Alert
//           onClose={handleCloseWarning}
//           severity="warning"
//           variant="filled"
//           sx={{
//             fontFamily: "Poppins"
//           }}
//         >
//           Cash on Delivery is currently unavailable. Please select Network Payment.
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default PaymentMethods;
